<template>
  <div class="p-4">
    <!-- Order Food -->
    <router-link
      class="relative block rounded-xl overflow-hidden"
      to="/submit-order"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../assets/img/banner_order.png" class="w-full" />
      </div>

      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Waiter' && userRole !== 'Admin'"
        @click.prevent
      ></div>
    </router-link>

    <div class="flex justify-between gap-4 mt-4">
      <!-- Menu -->
      <router-link class="relative block rounded-xl overflow-hidden" to="/menu">
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../assets/img/banner_menu.png" />
        </div>

        <div
          class="absolute w-full h-full top-0 bg-black/80"
          v-if="userRole !== 'Waiter' && userRole !== 'Admin'"
          @click.prevent
        ></div>
      </router-link>

      <!-- Factors -->
      <router-link
        class="relative block rounded-xl overflow-hidden"
        to="/my-factors"
      >
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../assets/img/banner_factor.png" />
        </div>

        <div
          class="absolute w-full h-full top-0 bg-black/80"
          v-if="userRole !== 'Waiter' && userRole !== 'Admin'"
          @click.prevent
        ></div>
      </router-link>
    </div>

    <!-- Management -->
    <router-link
      class="relative block rounded-xl overflow-hidden mt-4"
      to="/management"
    >
      <div
        class="transition-all transform"
        @touchstart="toggleAnimation($event)"
        @touchend="toggleAnimation"
      >
        <img src="../assets/img/banner_admin.png" class="w-full" />
      </div>

      <div
        class="absolute w-full h-full top-0 bg-black/80"
        v-if="userRole !== 'Admin' && userRole !== 'Hotel'"
        @click.prevent
      ></div>
    </router-link>

    <div class="flex justify-between gap-4 mt-4">
      <!-- Notification Inbox  -->
      <router-link to="/notification-inbox">
        <div
          class="rounded-xl overflow-hidden transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../assets/img/banner_messages.png" class="w-screen" />      
        </div>
      </router-link>

      <!-- Notes -->
      <router-link
        class="relative block rounded-xl overflow-hidden"
        to="/note-list"
      >
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../assets/img/banner_notes.png" class="w-screen" />
        </div>

        <div
          class="absolute w-full h-full top-0 bg-black/80"
          v-if="userRole !== 'Manager' && userRole !== 'Admin' && userRole!=='CermonyManager'"
          @click.prevent
        ></div>
      </router-link>
    </div>

    <router-link
        class="relative block rounded-xl overflow-hidden mt-4"
        to="#"
        @click="$store.dispatch('logout')"
      >
        <div
          class="transition-all transform"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation"
        >
          <img src="../assets/img/exit.png" class="w-full" />
        </div>
      </router-link>
  </div>
</template>

<script>
import { getNotificationList } from "../API/API";

export default {
  name: "Home",
  data() {
    return {
      messages: [],
    };
  },
  computed: {
    unreadMessagesCount() {
      let count = 0;
      this.messages.forEach((message) => {
        if (message.signaL_ISREAD !== 1) {
          count++;
        }
      });
      return count;
    },
    userRole() {
      return this.$store.state.user.role;
    },
  },
  async created() {
    this.messages = (await getNotificationList()).data.result;
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle("scale-95");
      event.currentTarget.classList.toggle("shadow");
    },
  },
};
</script>

<style scoped></style>
